import { captureException } from "@shuttlerock/observability";
import type { RouteBoundaryErrorContext } from "./RouteErrorBoundary/RouteErrorBoundary";

export function reportRouteBoundaryError(error: unknown, context: RouteBoundaryErrorContext) {
  captureException(error, {
    tags: {
      boundary: context.boundary,
    },
  });
}
